import { connect } from 'react-redux';
import asContentPage from 'components/hoc/asContentPage';
import { forceMiniPlayerState } from 'actions/player-actions';
import { setHidden } from 'actions/search-actions';
import withContentfulData from 'components/hoc/withContentfulData';

import FaqQuestionPage from './FaqQuestionPage';

const FaqQuestionPageContainer = connect(null, {
  forceMiniPlayerState,
  setSearchHidden: setHidden,
})(FaqQuestionPage);
export default asContentPage('faqQuestion', withContentfulData(FaqQuestionPageContainer));
